import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useContext, useRef } from 'react';
import { Icon } from '../index';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { tuple } from '../_utils/type';
import { getCompProps } from '../_utils';
import devWarning from '../_utils/devwarning';
export var TagTypes = tuple('status', 'attribute', 'text', 'edit');
export var TagColors = tuple('process', 'success', 'warning', 'error', 'end', 'expired');
export var TagSizes = tuple('small', 'middle', 'large'); // remove this line and code Tag component here

var InteranalTag = function InteranalTag(props, ref) {
  var _context, _context2, _context3, _classNames;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var tagProps = getCompProps('Tag', userDefaultProps, props);

  var className = tagProps.className,
      clickable = tagProps.clickable,
      closable = tagProps.closable,
      closeIcon = tagProps.closeIcon,
      color = tagProps.color,
      disabled = tagProps.disabled,
      icon = tagProps.icon,
      size = tagProps.size,
      type = tagProps.type,
      onClick = tagProps.onClick,
      onClose = tagProps.onClose,
      style = tagProps.style,
      customPrefixcls = tagProps.prefixCls,
      children = tagProps.children,
      others = __rest(tagProps, ["className", "clickable", "closable", "closeIcon", "color", "disabled", "icon", "size", "type", "onClick", "onClose", "style", "prefixCls", "children"]);

  devWarning(TagTypes.indexOf(type) === -1, 'tag', "cannot found tag type '".concat(type, "'"));
  devWarning(TagSizes.indexOf(size) === -1, 'tag', "cannot found tag size '".concat(size, "'"));
  var tagPrefixCls = getPrefixCls(prefixCls, 'tag', customPrefixcls);

  var handleClick = function handleClick(e) {
    if (!clickable) return;
    onClick && onClick(e);
  };

  var handleClose = function handleClose(e) {
    var _a;

    onClose && onClose(e);

    if (e.defaultPrevented) {
      return;
    } // 删除标签


    var tagWrapper = e.currentTarget.parentNode;
    (_a = tagWrapper === null || tagWrapper === void 0 ? void 0 : tagWrapper.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(tagWrapper);
  }; // ref


  var thisTagRef = useRef();
  var tagRef = ref || thisTagRef; // 对children进行进一步处理 当标签包含图标时 文本内容需要用标签包裹设置外边距

  var handleChild = function handleChild(child) {
    if (!child) return null;

    if (typeof child === 'string' && icon) {
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(tagPrefixCls, "-text")
      }, child);
    }

    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(tagPrefixCls, "-ellipsis")
    }, child);
  }; // 预设的颜色值


  var isPresetColor = ['process', 'success', 'warning', 'error', 'end', 'expired'].indexOf(color) > -1;
  var tagClasses = classNames(tagPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, _concatInstanceProperty(_context = "".concat(tagPrefixCls, "-shape-")).call(_context, type), type), _defineProperty(_classNames, _concatInstanceProperty(_context2 = "".concat(tagPrefixCls, "-")).call(_context2, color), isPresetColor), _defineProperty(_classNames, "".concat(tagPrefixCls, "-has-color"), !isPresetColor && color && type === 'attribute'), _defineProperty(_classNames, "".concat(tagPrefixCls, "-clickable"), clickable), _defineProperty(_classNames, "".concat(tagPrefixCls, "-closable"), closable), _defineProperty(_classNames, _concatInstanceProperty(_context3 = "".concat(tagPrefixCls, "-size-")).call(_context3, size), size), _defineProperty(_classNames, "".concat(tagPrefixCls, "-closable-disabled"), type === 'edit' && disabled), _classNames)); // 设置自定义颜色值的样式

  var tagColorStyle = !isPresetColor && color && type === 'attribute' ? {
    backgroundColor: color
  } : {};

  var tagStyle = _extends(_extends({}, tagColorStyle), style); // 图标


  var iconNode = icon || null;
  var tagChild = handleChild(children); // 关闭按钮

  var closeIconNode = closeIcon || /*#__PURE__*/React.createElement(Icon, {
    type: "close",
    className: "".concat(tagPrefixCls, "-close-icon")
  });
  var closeNode = closable && type === 'edit' ? disabled ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(tagPrefixCls, "-closeWrapper")
  }, closeIconNode) : /*#__PURE__*/React.createElement("span", {
    className: "".concat(tagPrefixCls, "-closeWrapper"),
    onClick: handleClose
  }, closeIconNode) : null;
  return /*#__PURE__*/React.createElement("span", _extends({
    ref: tagRef,
    onClick: handleClick,
    className: tagClasses,
    style: tagStyle
  }, others), iconNode, tagChild, closeNode);
};

var Tag = /*#__PURE__*/React.forwardRef(InteranalTag);
Tag.displayName = 'Tag';
export default Tag;